if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        /*
         * =====================================================
         * SLIDE CHANGE
         * =====================================================
         */

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(
            this.onSlideChanged.bind(this),
            500
          )
        );


        /*
         * =====================================================
         * THUMBNAIL CLICK
         * =====================================================
         */

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button =
                mediaToSwitch.querySelector('button');

              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });
        }


        /*
         * =====================================================
         * DESKTOP SEMANTICS
         * =====================================================
         */

        if (
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes(
            'thumbnail'
          ) &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }


        /*
         * =====================================================
         * VARIANT CHANGE LISTENER
         * =====================================================
         */

        this.setupVariantListener();


        /*
         * =====================================================
         * INITIAL VARIANT MEDIA ORDER
         * =====================================================
         */

        setTimeout(() => {
          this.reorderVariantMedia();
        }, 200);

        setTimeout(() => {
          this.reorderVariantMedia();
        }, 700);
      }


      /*
       * =====================================================
       * GET CURRENT VARIANT ID
       * =====================================================
       */

      getCurrentVariantId() {
        /*
         * Dawn product form
         */

        const variantInput =
          document.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );

        if (
          variantInput &&
          variantInput.value
        ) {
          return String(
            variantInput.value
          );
        }


        /*
         * URL fallback
         */

        const urlParams =
          new URLSearchParams(
            window.location.search
          );

        const urlVariant =
          urlParams.get('variant');

        if (urlVariant) {
          return String(urlVariant);
        }


        return null;
      }


      /*
       * =====================================================
       * VARIANT LISTENER
       * =====================================================
       */

      setupVariantListener() {
        /*
         * Dawn variant radio/select change
         */

        document.addEventListener(
          'change',
          (event) => {
            if (!event.target) return;

            const isVariantControl =
              event.target.matches(
                'variant-radios input[type="radio"]'
              ) ||
              event.target.matches(
                'variant-selects select'
              ) ||
              event.target.matches(
                'select[name^="options"]'
              ) ||
              event.target.matches(
                'input[name^="options"]'
              );

            if (!isVariantControl) return;


            /*
             * Dawn needs a moment to update
             * the variant input.
             */

            setTimeout(() => {
              this.reorderVariantMedia();
            }, 100);

            setTimeout(() => {
              this.reorderVariantMedia();
            }, 400);

            setTimeout(() => {
              this.reorderVariantMedia();
            }, 800);
          }
        );


        /*
         * Custom variant events
         */

        document.addEventListener(
          'variant:change',
          () => {
            setTimeout(() => {
              this.reorderVariantMedia();
            }, 100);
          }
        );


        document.addEventListener(
          'variantChange',
          () => {
            setTimeout(() => {
              this.reorderVariantMedia();
            }, 100);
          }
        );


        /*
         * Watch variant input
         */

        const variantInput =
          document.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );

        if (!variantInput) return;

        this.lastVariantId =
          variantInput.value;


        /*
         * Mutation observer
         */

        const observer =
          new MutationObserver(() => {
            const newVariantId =
              variantInput.value;

            if (
              newVariantId &&
              newVariantId !==
                this.lastVariantId
            ) {
              this.lastVariantId =
                newVariantId;

              this.reorderVariantMedia();
            }
          });


        observer.observe(
          variantInput,
          {
            attributes: true,
            attributeFilter: [
              'value',
            ],
          }
        );


        /*
         * Extra fallback for Dawn
         */

        setInterval(() => {
          const newVariantId =
            variantInput.value;

          if (
            newVariantId &&
            newVariantId !==
              this.lastVariantId
          ) {
            this.lastVariantId =
              newVariantId;

            this.reorderVariantMedia();
          }
        }, 300);
      }


      /*
       * =====================================================
       * REORDER SELECTED VARIANT MEDIA
       * =====================================================
       */

      reorderVariantMedia() {
        const variantId =
          this.getCurrentVariantId();

        if (!variantId) return;


        /*
         * Main gallery list
         */

        const viewerList =
          this.elements.viewer.querySelector(
            '.product__media-list'
          );

        if (!viewerList) return;


        /*
         * Get all media
         */

        const mediaItems =
          Array.from(
            viewerList.querySelectorAll(
              '[data-media-id]'
            )
          );

        if (!mediaItems.length) return;


        /*
         * Split media:
         *
         * selected variant media
         * +
         * other media
         */

        const selectedVariantMedia = [];
        const otherMedia = [];


        mediaItems.forEach(
          (media) => {
            const variantIds =
              this.getVariantIds(
                media
              );

            if (
              variantIds.includes(
                String(variantId)
              )
            ) {
              selectedVariantMedia.push(
                media
              );
            } else {
              otherMedia.push(
                media
              );
            }
          }
        );


        /*
         * No assigned media =
         * don't modify gallery.
         */

        if (
          !selectedVariantMedia.length
        ) {
          return;
        }


        /*
         * =================================================
         * SELECTED VARIANT FIRST
         * =================================================
         */

        const newOrder = [
          ...selectedVariantMedia,
          ...otherMedia,
        ];


        newOrder.forEach(
          (media) => {
            viewerList.appendChild(
              media
            );
          }
        );


        /*
         * =================================================
         * REORDER THUMBNAILS
         * =================================================
         */

        this.reorderThumbnails(
          selectedVariantMedia
        );


        /*
         * =================================================
         * RESET MAIN SLIDER
         * =================================================
         */

        if (
          this.elements.viewer.slider
        ) {
          this.elements.viewer.resetPages();
        }


        /*
         * =================================================
         * RESET THUMBNAIL SLIDER
         * =================================================
         */

        if (
          this.elements.thumbnails &&
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.resetPages();
        }


        /*
         * =================================================
         * FIRST SELECTED IMAGE ACTIVE
         * =================================================
         */

        const firstMedia =
          selectedVariantMedia[0];

        if (!firstMedia) return;


        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach(
            (element) => {
              element.classList.remove(
                'is-active'
              );
            }
          );


        firstMedia.classList.add(
          'is-active'
        );


        /*
         * =================================================
         * FIRST SELECTED THUMBNAIL ACTIVE
         * =================================================
         */

        if (
          this.elements.thumbnails
        ) {
          const thumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${firstMedia.dataset.mediaId}"]`
            );

          this.setActiveThumbnail(
            thumbnail
          );
        }
      }


      /*
       * =====================================================
       * GET VARIANT IDS FROM MEDIA
       * =====================================================
       */

      getVariantIds(element) {
        if (!element) return [];

        const value =
          element.dataset.variantIds;

        if (!value) return [];

        return value
          .split(',')
          .map(
            (id) => id.trim()
          )
          .filter(Boolean);
      }


      /*
       * =====================================================
       * REORDER THUMBNAILS
       * =====================================================
       */

      reorderThumbnails(
        selectedVariantMedia
      ) {
        if (
          !this.elements.thumbnails
        ) {
          return;
        }


        const thumbnailList =
          this.elements.thumbnails.querySelector(
            '.thumbnail-list'
          );

        if (!thumbnailList) return;


        const thumbnails =
          Array.from(
            thumbnailList.querySelectorAll(
              '[data-target]'
            )
          );


        const selectedIds =
          new Set(
            selectedVariantMedia.map(
              (media) =>
                media.dataset.mediaId
            )
          );


        const selectedThumbnails = [];
        const otherThumbnails = [];


        thumbnails.forEach(
          (thumbnail) => {
            if (
              selectedIds.has(
                thumbnail.dataset.target
              )
            ) {
              selectedThumbnails.push(
                thumbnail
              );
            } else {
              otherThumbnails.push(
                thumbnail
              );
            }
          }
        );


        const newThumbnailOrder = [
          ...selectedThumbnails,
          ...otherThumbnails,
        ];


        newThumbnailOrder.forEach(
          (thumbnail) => {
            thumbnailList.appendChild(
              thumbnail
            );
          }
        );
      }


      /*
       * =====================================================
       * SLIDE CHANGED
       * =====================================================
       */

      onSlideChanged(event) {
        const currentElement =
          event.detail.currentElement;

        if (!currentElement) return;


        const thumbnail =
          this.elements.thumbnails?.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );


        this.setActiveThumbnail(
          thumbnail
        );
      }


      /*
       * =====================================================
       * SET ACTIVE MEDIA
       * =====================================================
       */

      setActiveMedia(
        mediaId,
        prepend
      ) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );


        if (!activeMedia) return;


        /*
         * Remove active class
         */

        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach(
            (element) => {
              element.classList.remove(
                'is-active'
              );
            }
          );


        activeMedia.classList.add(
          'is-active'
        );


        /*
         * Original Dawn prepend behavior
         */

        if (prepend) {
          if (
            activeMedia.parentElement
              .firstChild !==
            activeMedia
          ) {
            activeMedia.parentElement.prepend(
              activeMedia
            );
          }


          if (
            this.elements.thumbnails
          ) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );


            if (
              activeThumbnail &&
              activeThumbnail.parentElement
                .firstChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }


          if (
            this.elements.viewer.slider
          ) {
            this.elements.viewer.resetPages();
          }
        }


        /*
         * Sticky header
         */

        this.preventStickyHeader();


        /*
         * Scroll
         */

        window.setTimeout(() => {
          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {
            activeMedia.parentElement.scrollTo(
              {
                left:
                  activeMedia.offsetLeft,
              }
            );
          }


          const activeMediaRect =
            activeMedia.getBoundingClientRect();


          if (
            activeMediaRect.top >
            -0.5
          ) {
            return;
          }


          const top =
            activeMediaRect.top +
            window.scrollY;


          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        });


        /*
         * Play media
         */

        this.playActiveMedia(
          activeMedia
        );


        /*
         * Thumbnail
         */

        if (
          !this.elements.thumbnails
        ) {
          return;
        }


        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );


        this.setActiveThumbnail(
          activeThumbnail
        );


        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset
              .mediaPosition
          );
        }
      }


      /*
       * =====================================================
       * SET ACTIVE THUMBNAIL
       * =====================================================
       */

      setActiveThumbnail(
        thumbnail
      ) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }


        this.elements.thumbnails
          .querySelectorAll(
            'button'
          )
          .forEach(
            (element) => {
              element.removeAttribute(
                'aria-current'
              );
            }
          );


        const button =
          thumbnail.querySelector(
            'button'
          );


        if (button) {
          button.setAttribute(
            'aria-current',
            'true'
          );
        }


        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }


        if (
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.slider.scrollTo(
            {
              left:
                thumbnail.offsetLeft,
            }
          );
        }
      }


      /*
       * =====================================================
       * ANNOUNCE LIVE REGION
       * =====================================================
       */

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (
          !this.elements.liveRegion
        ) {
          return;
        }


        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );


        if (!image) return;


        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );


          if (
            window.accessibilityStrings &&
            window.accessibilityStrings
              .imageAvailable
          ) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
          }


          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };


        image.src = image.src;
      }


      /*
       * =====================================================
       * PLAY ACTIVE MEDIA
       * =====================================================
       */

      playActiveMedia(
        activeItem
      ) {
        if (
          typeof window.pauseAllMedia ===
          'function'
        ) {
          window.pauseAllMedia();
        }


        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );


        if (deferredMedia) {
          deferredMedia.loadContent(
            false
          );
        }
      }


      /*
       * =====================================================
       * PREVENT HEADER REVEAL
       * =====================================================
       */

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );


        if (!this.stickyHeader) {
          return;
        }


        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );
      }


      /*
       * =====================================================
       * REMOVE LIST SEMANTIC
       * =====================================================
       */

      removeListSemantic() {
        if (
          !this.elements.viewer.slider
        ) {
          return;
        }


        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );


        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );
      }
    }
  );
}